/**
 * Frontend configuration.
 *
 * Values come from Vite environment variables at build time. There is no
 * storage, cloud, or credential configuration here by design.
 */

export const API_URL = (import.meta.env.VITE_API_URL || 'http://localhost:8000').replace(/\/$/, '');

/** How often the landing page re-checks backend health, in milliseconds. */
export const HEALTH_POLL_INTERVAL_MS = 15000;

/**
 * Maximum caption entries kept in memory.
 *
 * A long conversation would otherwise grow the transcript list without bound.
 * The full transcript is persisted server-side by the voice agent.
 */
export const MAX_CAPTIONS = 200;

/** How often an internal page re-reads a session's discovery stage, in milliseconds. */
export const DISCOVERY_POLL_INTERVAL_MS = 4000;

/**
 * How often the client's page asks whether the assessment has finished.
 *
 * The client is told one thing about the internal engine — whether it is over
 * — so this is the only poll the assessment page makes.
 */
export const ASSESSMENT_POLL_INTERVAL_MS = 4000;

/**
 * How long to wait for NS Assistant to join the room before telling the user
 * something is wrong.
 *
 * Generous on purpose: the worker holds its models in memory and normally
 * joins within a second or two, but a first run that is still loading them
 * can take longer, and a false alarm during a real interview is worse than a
 * few extra seconds of patience.
 */
export const AGENT_JOIN_TIMEOUT_MS = 20000;

/**
 * The reverse-pyramid discovery model.
 *
 * INTERNAL ONLY. These stage names are how the discovery engine thinks, not
 * how a conversation feels, and a client is never shown them — no page under
 * `src/client/` imports this.
 */
export const DISCOVERY_LAYERS = [
  { id: 'L1', label: 'Identity / Organisation' },
  { id: 'L2', label: 'Business' },
  { id: 'L3', label: 'Industry / Vertical' },
  { id: 'L4', label: 'Technology / Existing Environment' },
  { id: 'L5', label: 'Pain / Problem Discovery' },
  { id: 'L6', label: 'Deep Dive' },
  { id: 'L7', label: 'Confirm Problem' },
  { id: 'L8', label: 'Documents / Closing' },
];
